import asyncActionTypes from '../actions/types';

const initialState = {
  ffNumber: '',
  tokenWasInvalid: false,
};

const tokenInvalidSecurity = (state = initialState, action) => {
  if (action.type === asyncActionTypes.TOKEN_INVALID_SECURITY) {
    return {
      ...state,
      ffNumber: action.ffNumber,
      tokenWasInvalid: action.tokenWasInvalid,
    };
  } else {
    return state;
  }
};

export default tokenInvalidSecurity;

